import { AbstractPmsApiService } from "./abstract.service";
import { Token, User } from "../models";

export class AuthAccessPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/auth';
    }

    /**
     * @param {{user: Object.<string, *>, token: Object.<string, *>}} attributes
     * @param {...*} params
     * @return {{user: User, token: Token}}
     * @protected
     */
    newModel({user, token, otp_required, otp_sent}, ...params) {

        return {
            user: new User(user),
            token: new Token(token),
            otp_required,
            otp_sent
        };
    }

    /**
     * @param {string} email
     * @param {string} password
     * @param {boolean} remember
     * @param {boolean} isBilling
     * @return {Promise.<{user: User, token: Token}>}
     */
    request(email, password, remember = false, isBilling = false) {

        const url = this.url() + '/access',
            payload = {
                email,
                password
            };

        if (remember) {

            payload['remember'] = true;
        }

        if (isBilling) {

            payload['isBilling'] = true;
        }

        return this.http
                   .post(url, payload, {headers: this.headers})
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {string} refreshToken
     * @return {Promise.<{token: Token}>}
     */
    refresh() {
        
        const url = this.url() + '/refresh';
        const payload = {};


        return this.http
                   .post(url, payload, {headers: this.authHeaders})
                   .then(res => {
                    return {
                        token: new Token(res.data)
                    }
                   })
                   .catch(this.getErrorHandler());
    }

    requestBillingPortalAuth() {

        const url = this.url() + '/access/billing';

        const payload = {
            isBilling: true,
        };

        return this.http
            .post(url, payload, {headers: this.authHeaders})
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @return {Promise.<true>}
     */
    revoke(params = {}) {

        const url = this.url() + '/access';

        return this.http
                   .delete(url,
                       {
                           headers: this.authHeaders,
                           params: params,
                       })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }


    verifyOtp(otp, token){
        const url = this.url() + '/verify-opt';

        return this.http
            .post(
                url,
                { otp },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/auth-access.service.js